module.exports = __webpack_public_path__ + "static/media/400147_02.3e8a25fe.png";